<div class="billing-info" *ngIf="!isLoading; else loader" style="padding:15px">
  <div class="payment-hero mt-30 mb-20">
    <div class="payment-info-container" *ngIf="paymentInfoData; else noInfo">
      <div class="payment-due mb-3 mt-40 mb-20">
        <span *ngIf="paymentInfoData?.IsAmountOverDue;else notOverDue">
          <adp-label labelKey="Account_Billing_Payment_AmountDue"></adp-label>
        </span>
        <span> {{ paymentInfoData?.InstallmentAmount | currency }}</span>
      </div>
      <div class="div-line mt-20 mb-20"></div>
      <div class="billing-tab" id="billingTab">
        <div class="row">
          <div class="col-md-12">
            <form [formGroup]="paymentFormGroup" name="paymentFormGroup" class="payment-form-group form-ls" novalidate>
              <div>
                <div class="row payment-info">
                  <mat-form-field class="width-field">
                    <adp-label labelKey="Account_Billing_Payment_BillingAddress1"></adp-label>
                    <input matInput class="field-input cls_mask" [value]="defaultAddress" formControlName="BillingAddress1"
                      pghMatGoogleMapsAutocompleteCustom [country]="'us'"
                      (onAutocompleteSelected)="onAddressMapped($event)" />
                    <mat-error pgh-input-error controlName="BillingAddress1" [label]="getLabel('Account_Billing_Payment_BillingAddress1')"
                      [errorMessages]="{
                        maxlength: getLabel('Global_Text_VMMaxLength'),
                        required: getLabel('Global_Error_Address_Required')
                      }" >
                    </mat-error>
                  </mat-form-field>
                  <div class="card-row fullWidth">
                    <adp-input [resourceData]="getResource('BillingAddress2')" formControlName="BillingAddress2">
                    </adp-input>
                  </div>
                  <div class="card-row fullWidth col-md-4">
                    <adp-input [resourceData]="getResource('City')" formControlName="City">
                    </adp-input>
                  </div>
                  <div class="card-row fullWidth col-md-4">
                    <adp-select [resourceData]="getResource('State')" formControlName="State" [listItems]="states"></adp-select>
                  </div>
                  <div class="card-row fullWidth col-md-4">
                    <adp-input [resourceData]="getResource('ZipCode')" formControlName="ZipCode" pghNumber>
                    </adp-input>
                  </div>
                </div>

                <div class="payment-container">
                  <div class="row mt-3 mb-4">
                    <div class="col col-12 col-sm-4 align-self-center">
                      <span class="cc-label">
                        <adp-label labelKey="Account_Billing_Payment_CreditCard"></adp-label>
                      </span>
                    </div>
                    <div class="col col-12 col-sm-8 d-flex ms-sm-auto w-auto">
                      <ul class="d-inline-flex m-0 card-img-wrap">
                        <li class="card-image" [ngClass]="creditCardType === 'AMEX' ? 'active' : ''" id="AmericanExpress">
                          <img class="payment-logo" alt="amex card" src="../../../assets/images/img-amex.jpg" />
                        </li>
                        <li class="card-image" [ngClass]="creditCardType === 'MC' ? 'active' : ''"  id="MasterCard">
                          <img class="payment-logo" alt="master card" src="../../../assets/images/img-mastercard.jpg" />
                        </li>
                        <li class="card-image" [ngClass]="creditCardType === 'VISA' ? 'active' : ''" id="Visa">
                          <img class="payment-logo" alt="visa card" src="../../../assets/images/img-visa.jpg" />
                        </li>
                        <li class="card-image" [ngClass]="creditCardType === 'DISCOVER' ? 'active' : ''" id="Discover">
                          <img class="payment-logo" alt="discover card" src="../../../assets/images/img-discover.jpg" />
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div class="credit-card">
                    <div class="row">
                      <div class="card-row fullWidth">
                        <adp-input [resourceData]="getResource('Name', 'Account_Billing_Payment_CreditCard')" formControlName="Name">
                        </adp-input>
                      </div>
                      <mat-form-field  class="col-12">
                        <mat-label class="field-label">
                          <adp-label labelKey="Account_Billing_Payment_CreditCard"></adp-label>
                        </mat-label>
                        <input matInput class="field-input cls_mask" formControlName="CardNumber"
                          [pghNumber]="creditCardType === 'AMEX' ? '####-######-#####' : '####-####-####-####'"
                          [pghNumberLength]="creditCardType === 'AMEX' ? 15 : 16" [pghNumberHideValue]="true"
                          name="CardNumber" />
                        <mat-error pgh-input-error [errorMessages]="{ccNumber: getLabel('Global_Error_CreditCard_Invalid')}"
                          controlName="CardNumber" [label]="getLabel('Account_Billing_Payment_CreditCard')">
                        </mat-error>
                      </mat-form-field>
                      <mat-form-field id="expDate" class="col-12 col-md-6">
                        <mat-label class="field-label">
                          <adp-label labelKey="Account_Billing_Payment_CreditCard_ExpDate"></adp-label>
                        </mat-label>
                        <input inputmode="numeric cls_mask" maxlength="5" autocomplete="cc-exp" matInput class="field-input"
                          formControlName="ExpirationDate" [matDatepicker]="dp" [rangePicker]="picker"
                          placeholder="MM/YY" [min]="minDate" [max]="maxDate" monthYear numbersOnly />
                        <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                        <mat-datepicker #dp #picker startView="multi-year" (yearSelected)="onYearSelected($event)"
                          (monthSelected)="onMonthSelected($event, dp)" panelClass="example-month-picker">
                        </mat-datepicker>
                        <mat-error class="custom-mat-error" pgh-input-error controlName="ExpirationDate"
                          [errorMessages]="{minDate: getLabel('Global_Error_CreditCard_MinExpDate')}"
                          [label]="getLabel('Account_Billing_Payment_CreditCard_ExpDate')">
                        </mat-error>
                      </mat-form-field>
                      <mat-form-field class="col-12 col-md-6">
                        <mat-label class="field-label">
                          <adp-label labelKey="Account_Billing_Payment_CreditCard_CVV"></adp-label>
                        </mat-label>
                        <input matInput class="field-input cls_mask" formControlName="CvvCode" pghNumber
                          [pghNumberLength]="creditCardType === 'AMEX' ? 4 : 3" [pghNumberHideValue]="true" />
                        <mat-error pgh-input-error controlName="CvvCode"
                          [label]="getLabel('Account_Billing_Payment_CreditCard_CVV')">
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>

                <div class="row accept-terms">
                  <div class="col-md-12 mt-4">
                    <section>
                      <mat-checkbox formControlName="PaymentConsent" id="additional-authorize" class="accept-terms_checkbox" color="primary">
                        <span [innerHTML]="getLabel('Account_Billing_Payment_AcceptTermsCopy')"></span>
                      </mat-checkbox>
                    </section>
                  </div>
                  <div class="col-12 col-md-6 mt-3">
                    <button mat-flat-button *ngIf="!isClicked" color="accent" (click)="updatePaymentDetails()"
                      [disabled]="!paymentFormGroup?.valid">
                      <adp-label *ngIf="paymentInfoData?.IsAmountOverDue; else updateButtonText" labelKey="Account_Billing_Payment_PayOverdueAmountButton"></adp-label>
                    </button>
                    <button mat-flat-button *ngIf="isClicked" color="accent" [disabled]="true">
                      <adp-label *ngIf="paymentInfoData?.IsAmountOverDue; else updateButtonText" labelKey="Account_Billing_Payment_PayOverdueAmountButton"></adp-label>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <!-- <pgh-account-details [(updatePaymentMessage)]="updatePaymentMessage"
                            [selectedContract]="selectedContract"
                            [user]="user">
        </pgh-account-details> -->
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #notOverDue>
  <adp-label labelKey="Account_Billing_Payment_NextPaymentAmountDue"></adp-label>
</ng-template>

<ng-template #updateButtonText>
  <adp-label labelKey="Account_Billing_Payment_UpdatePaymentButton"></adp-label>
</ng-template>

<ng-template #noInfo>
  <div class="no-info" *ngIf="!isLoading && !paymentInfoResponse">
    <span>
      <adp-label labelKey="Account_Billing_Payment_NoPaymentInfo"></adp-label>
    </span>
    <img src="../../../assets/images/dashboard-hero.svg" alt="" />
  </div>
</ng-template>

<ng-template #loader>
  <div class="loader">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>
</ng-template>
